import classnames from 'classnames';
import { TmdxAvatar } from '@ds';
// import { PhoneUrl, MessageUrl, CameraUrl } from '@icons';
import { UserInfoModal } from '@features/modals/UserInfoModal';
import { specialistCssStyles, SpecialistStylesStyle } from '@features/components/CaseCard/Blocks/Base/specialistStyles';
import { MdOutlineWifiTethering } from 'react-icons/md';
import { ChipWithStatus } from '@ui';
import { MiniCard } from '../Base/MiniCard';
import { getColorsByOrganType } from '@/utils/helpers';
import { Uuid } from '@/api/types';
import { useComposedEmployeeByIdQuery } from '@/queries/employee';
import { roleNames } from '@/constants/user.constants';
import { EmployeeLabels, OrganType } from '@/api/apis/case';
import { EmployeeRole } from '@/api/apis/resources';
import { employeeLabelColors, employeeLabelName } from '@/constants/resources.constants';

type ResourceCardProps = {
  photo?: string;
  role: EmployeeRole;
  name?: string;
  organType: OrganType;
  employeeId: Uuid;
  labels?: EmployeeLabels[] | null;
};

const sharedEmployeeRoles = [
  EmployeeRole.ClinicalCoordinator,
  EmployeeRole.RetrievalSurgeon,
  EmployeeRole.ClinicalSpecialist,
];

export const ResourceCard = ({ employeeId, photo, role, name, organType, labels }: ResourceCardProps) => {
  const { data } = useComposedEmployeeByIdQuery(employeeId);
  const colors = getColorsByOrganType(organType);
  const hasShareIcon = sharedEmployeeRoles.includes(role);
  const hasLabels = !!labels?.length;

  return (
    <UserInfoModal user={data}>
      <MiniCard
        classNames={colors.bg80}
        label={name}
        value={roleNames[role]}
        leftItem={
          <div className={classnames('flex flex-col', hasLabels && '-mb-2.5')}>
            <TmdxAvatar size="lg" radius="lg" name={name} src={photo} className="mr-2 w-8 h-8" />
            {hasLabels && (
              <ChipWithStatus
                variant="solid"
                size="xxs"
                color={employeeLabelColors[labels[0]]}
                className="relative bottom-0 -left-2.5 -top-1.25"
              >
                <span className="text-success-5">{employeeLabelName[labels[0]]}</span>
              </ChipWithStatus>
            )}
          </div>
        }
        rightItem={null}
        icon={
          hasShareIcon && (
            <div className={`p-0.5 rounded-full ${colors.bg60}`}>
              <MdOutlineWifiTethering className="text-base-20" />
            </div>
          )
        }
        //   <div className="flex gap-3">
        //     <Image src={PhoneUrl} />
        //     <Image src={MessageUrl} />
        //     <Image src={CameraUrl} />
        //   </div>
        // }
        cssStyles={specialistCssStyles[SpecialistStylesStyle.base]}
      />
    </UserInfoModal>
  );
};
